const CasualtiesByUserGroup = {
    chart: {
        backgroundColor: '#F5F5F5',
        borderRadius: 8,
        marginTop: 35,
        marginBottom: 10,
        minWidth: 260,
        maxWidth: 480,
        height: 216
    },
    title: {
        text: "Casualties by user group",
        align: 'left',
        style: {
            fontFamily: 'Stolzl-Medium',
            fontStyle: 'normal',
            color: '#282B2D',
            textDecoration: 'none',
            fontSize: 14,
            fontWeight: '500',
            lineHeight: 18,
            whiteSpace: 'nowrap'
        }
    },
    dataLabels: {
        style: {
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 400,
            textDecoration: 'none',
            fontSize: '20px',
            textOutline: 'none',
            lineHeight: '28px',
            textAlign: 'right',
            color: '#3E4756'
        },
    },
    // exporting: {
    //     enabled: false
    // },
    legend: {
        enabled: false
    },
    tooltip: {
        enabled: false
    },
    credits: {
        enabled: false
    },
    colorAxis: {
        minColor: '#FFFFFF',
        // maxColor: Highcharts.getOptions().colors[0]
    },
    exporting: {
        enabled: false,
    },
    // exporting: {
    //     allowHTML: true
    // },
    series: [{
        type: 'treemap',
        // layoutAlgorithm: 'squarified',
        borderColor: "#ffffff",
        borderWidth: 1,
        // animation: false,
        alternateStartingDirection: true,
        // layoutAlgorithm: 'sliceAndDice',
        levels: [{
            level: 1,
            layoutAlgorithm: 'squarified',
            dataLabels: {
                enabled: true,
                style: {
                    fontFamily: 'Roboto',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    textDecoration: 'none',
                    fontSize: '20px',
                    textOutline: 'none',
                    lineHeight: '28px',
                    textAlign: 'right',
                    color: '#3E4756'
                },
            }
        }],
        colorByPoint: true,
        data: [
            {
                id: "car",
                name: '42%',
                dataLabels: {
                    align: 'right',
                    verticalAlign: 'top',
                    useHTML: true,
                    formatter: function () {
                        return '<span style=" font-size:' + (14 + this.point.value / 5) + 'px">' + this.key + '</span>'
                    },
                    enabled: true,
                },
            },
            {
                parent: 'car',
                color: '#B8D1FD',
                dataLabels: {
                    useHTML: true,
                    formatter: function () {
                        return '<img src="/Car.svg" style=" height:' + (30 + this.point.value / 2)
                            + 'px; width:' + (30 + this.point.value / 2) + 'px; margin-bottom: -5px; "/>'
                    },
                    enabled: true,
                    align: 'left',
                    verticalAlign: 'bottom',
                },
                value: 42,
            },
            {
                id: 'bicycle',
                name: '21%',
                dataLabels: {
                    useHTML: true,
                    align: 'right',
                    verticalAlign: 'top',
                    formatter: function () {
                        return '<span style=" font-size:' + (14 + this.point.value / 5) + 'px">' + this.key + '</span>'
                    },
                    enabled: true,
                },

            },
            {
                parent: 'bicycle',
                color: '#FFD48E',
                dataLabels: {
                    useHTML: true,
                    formatter: function () {
                        return '<img src="/Bicycle.svg" style=" height:' + (30 + this.point.value / 2)
                            + 'px; width:' + (30 + this.point.value / 2) + 'px; margin-bottom: -5px"/>'
                    },
                    enabled: true,
                    align: 'left',
                    verticalAlign: 'bottom',
                },
                value: 31,
            },
            {
                id: 'moto',
                name: '12%',
                dataLabels: {
                    useHTML: true,
                    align: 'right',
                    verticalAlign: 'top',
                    formatter: function () {
                        return '<span style=" font-size:' + (14 + this.point.value / 5) + 'px">' + this.key + '</span>'
                    },
                    enabled: true,
                },
            },
            {
                parent: 'moto',
                color: '#D7CEFC',
                dataLabels: {
                    useHTML: true,
                    formatter: function () {
                        return '<img src="/Moto.svg" style=" height:' + (30 + this.point.value / 2)
                            + 'px; width:' + (30 + this.point.value / 2) + 'px; margin-bottom: -5px"/>'
                    },
                    enabled: true,
                    align: 'left',
                    verticalAlign: 'bottom',
                },
                value: 12,
            },
            {
                id: 'smallMoto',
                name: '13%',
                dataLabels: {
                    useHTML: true,
                    align: 'right',
                    verticalAlign: 'top',
                    formatter: function () {
                        return '<span style=" font-size:' + (14 + this.point.value / 5) + 'px">' + this.key + '</span>'
                    },
                    enabled: true,
                },
            }, {
                parent: 'smallMoto',
                color: "#FFBDB4",
                dataLabels: {
                    useHTML: true,
                    formatter: function () {
                        return '<img src="/SmallMoto.svg" style=" height:' + (30 + this.point.value / 2) +
                            'px;width:' + (30 + this.point.value / 2) + 'px; margin-bottom: -5px"/>'
                    },
                    enabled: true,
                    align: 'left',
                    verticalAlign: 'bottom',
                },
                value: 13,
            }, {
                id: 'footPassenger',
                name: '1%',
                dataLabels: {
                    useHTML: true,
                    align: 'right',
                    verticalAlign: 'top',
                    formatter: function () {
                        return '<span style=" font-size:' + (14 + this.point.value / 5) + 'px; vertical-align: top">' + this.key + '</span>'
                    },
                    enabled: true,
                },
            }, {
                parent: 'footPassenger',
                color: '#B0EEC9',
                dataLabels: {
                    useHTML: true,
                    formatter: function () {
                        return '<img src="/Pedestrian.svg" style=" height:' + (30 + this.point.value / 2)
                            + 'px; width:' + (30 + this.point.value / 2) + 'px; margin-bottom: -5px"/>'
                    },
                    enabled: true,
                    align: 'left',
                    verticalAlign: 'bottom',
                },
                value: 4,
            }]
    }],
}
export default CasualtiesByUserGroup;
